import React from "react";
import Banner from "./Banner";

const Header = () => (
  <header id="home">
    <Banner />
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js